import React from 'react'
import { SmallCount as SmallCountStyled } from '../../styles/ListingsStyles'

function SmallCount({ count }: { count: number }) {
  return (
    <SmallCountStyled>
        {count} {count > 1 ? 'listings' : 'listing'}
    </SmallCountStyled>
  )
}

export default SmallCount